// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DbJ5hqFUsk98gv {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 0;
}
.DbJ5hqFUsk98gv p {
  padding: var(--ds-space-200, 16px);
}
.DbJ5hqFUsk98gv section {
  padding-bottom: var(--ds-space-200, 16px);
  overflow-y: auto;
  scrollbar-width: none;
}
.DbJ5hqFUsk98gv footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  margin-top: auto;
  margin-bottom: var(--ds-space-300, 24px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  background: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.r13Qmi7L02xYTa {
  display: flex;
  column-gap: var(--ds-space-050, 4px);
}
.xpi0k6CrWj4sHu {
  margin-right: var(--ds-space-100, 8px);
}
.oexRu8M2V5cFHP {
  margin: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedWorkspace": `DbJ5hqFUsk98gv`,
	"buttons": `r13Qmi7L02xYTa`,
	"icon": `xpi0k6CrWj4sHu`,
	"offeringLozenge": `oexRu8M2V5cFHP`
};
export default ___CSS_LOADER_EXPORT___;
